"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DebugErrorBoundaryContext = exports.TrackingFunctionContext = void 0;
const react_1 = require("react");
exports.TrackingFunctionContext = (0, react_1.createContext)(() => {
    throw new Error('No TrackingFunctionContext.Provider found in component tree');
});
exports.DebugErrorBoundaryContext = (0, react_1.createContext)(false);
//# sourceMappingURL=contexts.js.map